<div class="level-badge flex items-center gap-2 px-2 py-2 rounded" [ngClass]="bgColorClass">
  @if (level !== 'ORGANIZATION') {
    <div class="flex" style="gap: 2px">
      @for (star of getFilledStarArray(); track $index) {
        <ion-icon name="star" class="text-black text-[8px]"></ion-icon>
      }
      @for (star of getEmptyStarArray(); track $index) {
        <ion-icon name="star" class="text-white text-[8px]" style="opacity: 60%"></ion-icon>
      }
    </div>
  }
  <span class="text-black uppercase tracking-wider">{{ level }}</span>
</div>
